/* redux acion types */

// nav
export const GOTO_SECTION = 'goto_section'
export const TOGGLE_SIDEBAR = 'toggle_sidebar'
export const DISPLAY_LOADER = 'display_loader'
export const DISPLAY_FETCHING_LOADER = 'display_fetching_loader'
export const DISPLAY_MAIN_HEADER = 'display_main_header'

// map
export const FETCH_MAP_LIST = 'fetch_map_list'
export const SET_CURRENT_MAP = 'set_current_map'
export const UPDATE_REPORT_LAYER = 'update_report_layer'
export const RESET_CLICK_MAP_ITEM = 'reset_click_map_item'
export const RESET_MAP_CLICK_BY_LAYER_ID = 'reset_map_click_by_layer_id'
export const RESET_MAP = 'reset_map'
export const NEW_CENTER = 'new_center'
export const SET_BOUNDS = 'set_bounds'
export const TOGGLE_STREETS = 'toggle_streets'
export const UPDATE_TABLE_HEIGHT = 'update table height'
export const ADD_DRAWN_FEATURE = 'add_drawn_feature'
export const UPDATE_DRAWN_FEATURE = 'update_drawn_feature'
export const DELETE_DRAWN_FEATURE = 'delete_drawn_feature'
export const ATTEMPT_GEO_QUERY = 'attempt_geo_query'
export const ADD_GEO_QUERY_RESULTS = 'add_geo_query_results'
export const DELETE_GEO_QUERY_RESULTS = 'delete_geo_query_results'
export const SET_FEATURE_STATE = 'set_feature_state'
export const CLEAR_SET_FEATURE_STATE = 'clear_set_feature_state'
export const SET_POP_DOWN = 'SET_POP_DOWN'

// map/layer
export const ADD_INITIAL_LAYER = 'add_initial_layer'
export const FETCH_LAYER_OPTIONS = 'fetch_layer_options'
export const FETCH_PUBLIC_POI_OPTIONS = 'fetch_public_poi_options'
export const FETCH_CUSTOM_POI_OPTIONS = 'fetch_custom_poi_options'
export const ADD_REPORT_LAYER_TO_MAP = 'add_report_layer_to_map'
export const ADD_REPORT_AOI_LAYER_TO_MAP = 'add_report_aoi_layer_to_map'
export const ADD_POI_LAYER_TO_MAP = 'add_poi_layer_to_map'
export const SELECT_LAYER = 'select_layer'
export const UPDATE_REPORT_LAYER_MARKER_STYLE = 'update_report_layer_marker_style'
export const UPDATE_POI_LAYER_MARKER_STYLE = 'update_poi_layer_marker_style'

// Used in tegola demographic layers
export const UPDATE_DEMOGRAPHIC_LAYER = 'update_demographic_layer'
export const TOGGLE_LAYER = 'toggle_layer'
export const REMOVE_LAYER = 'remove_layer'
export const REMOVE_PROXIMITY_BY_REPORT = 'remove_proximity_by_report'
export const REMOVE_ISOCHRONE_BY_REPORT = 'remove_isochrone_by_report'
export const REMOVE_ENRICHMENT_BY_REPORT = 'remove_enrichment_by_report'
export const ADD_TEGOLA_LAYER_TO_MAP = 'add_tegola_layer_to_map'
export const EDIT_REPORT_LAYER_DATA = 'edit_report_layer_data'
// Used for the aoi enrichment layer
export const ADD_ENRICHMENT = 'add_enrichment'
export const UPDATE_ENRICHMENT_DATA = 'update_enrichment_data'
export const UPDATE_ENRICHMENT_FILL_STYLE = 'update_enrichment_fill_style'
export const TOGGLE_ENRICHMENT = 'toggle_enrichment'
export const SET_ENRICHMENT_METRIC = 'set_enrichment_metric'
export const SET_ENRICHMENT_FILTER_RANGE = 'set_enrichment_filter_range'
export const CLEAR_ENRICHMENT_DATA = 'clear_enrichment_data'
export const ADD_GEO_QUERY_INTERSECT_LAYER = 'ADD_GEO_QUERY_INTERSECT_LAYER'
export const UPDATE_GEO_QUERY_INTERSECT_LAYER = 'UPDATE_GEO_QUERY_INTERSECT_LAYER'
export const TOGGLE_GEO_QUERY_INTERSECT_LAYER = 'TOGGLE_GEO_QUERY_INTERSECT_LAYER'
export const REMOVE_GEO_QUERY_INTERSECT_LAYER = 'REMOVE_GEO_QUERY_INTERSECT_LAYER'
export const REMOVE_ALL_GEO_QUERY_INTERSECT_LAYERS_BY_AREA = 'REMOVE_ALL_GEO_QUERY_INTERSECT_LAYERS_BY_AREA'
export const ADD_PROXIMITY_LAYER_TO_MAP = 'add_proximity_layer_to_map'
export const UPDATE_PROXIMITY_LAYER = 'update_proximity_layer'
export const REMOVE_PROXIMITY_LAYER = 'remove_proximity_layer'
export const ADD_ISOCHRONE_LAYER_TO_MAP = 'add_isochrone_layer_to_map'
export const UPDATE_ISOCHRONE_LAYER = 'update_isochrone_layer'
export const REMOVE_ISOCHRONE_LAYER = 'remove_isochrone_layer'

// map/sidebar
export const UPDATE_SIDEBAR_COLUMNS = 'update_sidebar_columns'
export const ADD_SIDEBAR_ITEM = 'add_sidebar_item'
export const REMOVE_SIDEBAR_ITEM = 'remove_sidebar_item'
export const REMOVE_SIDEBAR_ITEM_BY_LAYER_ID = 'remove_sidebar_item_by_layer_id'
export const REMOVE_REPORT_POI_BY_POI_ID = 'remove_report_poi_by_poi_id'
export const SET_UNSAVED_CHANGES = 'set_unsaved_changes'

// widgets
export const SET_DB_WIDGETS = 'set_db_widgets'
export const ADD_WIDGET = 'add_widget'
export const REMOVE_WIDGET = 'remove_widget'
export const UPDATE_WIDGET = 'update_widget'
export const UPDATE_WIDGET_GRID_LAYOUT = 'update_widget_grid_layout'
export const UPDATE_WIDGET_GRID = 'update_widget_grid'
export const SET_WIDGET_GRID_CONFIG = 'set_widget_grid_config'

// slates
export const ADD_SLATE = 'add_slate'
export const DELETE_SLATE = 'delete_slate'
export const UPDATE_SLATE = 'update_slate'
export const UPDATE_SLATE_GRID = 'update_slate_grid'
export const UPDATE_SLATE_WIDGET_GRID = 'update_slate_widget_grid'
export const SET_SLATE_CONFIG = 'set_slate_config'
export const SWAP_SLATE_WIDGET = 'SWAP_SLATE_WIDGET'

export const SET_UNSAVED_SLATE_CHANGES = 'set_unsaved_slate_changes'
export const ADD_SLATE_WIDGET = 'add_slate_widget'
export const DELETE_SLATE_WIDGET = 'delete_slate_widget'
export const UPDATE_SLATE_WIDGET = 'update_slate_widget'
export const UPDATE_SLATE_WIDGET_GRID_LAYOUT = 'update_slate_widget_grid_layout'
export const SET_DEFAULT_WIDGET_GRID_CONFIG = 'set_default_widget_grid_config'

// map popup
export const ENABLE_POPUP = 'enable_popup'
export const DISABLE_POPUP = 'disable_popup'
export const UPDATE_POPUP = 'update_popup'

// customer selection
export const SELECT_WHITELABEL = 'select_whitelabel'
export const SELECT_CUSTOMER = 'select_customer'

export const CHANGE_INTERACTION_LAYER = 'change_interaction_layer'
export const DISPLAY_GQ_LOADER = 'display_gq_loader'

// original kepler config for comparison for save checks
export const SET_ORIGINAL_KCONFIG = 'SET_ORIGINAL_KCONFIG'
